import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { Grid, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { BaseDialog } from 'components'

import useAuthGuest from 'hooks/useAuthGuest'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import useStyles from './styles'

const UserSettingsDialog = ({ open, setOpen }) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { user, setUser } = useAuthGuest()

  const [responsibleName, setResponsibleName] = useState('')
  const [departmentId, setDepartmentId] = useState(null)
  const [departments, setDepartments] = useState([])
  const [isSaving, setIsSaving] = useState(false)
  const [isLoadingDepartments, setIsLoadingDepartments] = useState(false)

  useEffect(() => {
    if (!open) return
    setResponsibleName(user?.responsibleName || '')
    setDepartmentId(user?.departmentId || null)

    const fetchDepartments = async () => {
      setIsLoadingDepartments(true)
      try {
        const response = await service.guestPortal.departments.get({
          perPage: 1000,
          order: 'name ASC',
          minimal: true,
        })
        setDepartments(response?.data?.departments || [])
      } catch {
        snackbar.open({
          message: 'Não foi possível carregar os departamentos.',
          variant: 'error',
        })
      } finally {
        setIsLoadingDepartments(false)
      }
    }
    fetchDepartments()
  }, [open])

  const handleSave = async () => {
    setIsSaving(true)
    try {
      await service.guestPortal.profile.update({
        responsibleName,
        departmentId,
      })
      setUser({
        ...user,
        responsibleName: responsibleName || null,
        departmentId,
      })
      snackbar.open({ message: 'Configurações salvas.', variant: 'success' })
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao salvar configurações.',
        variant: 'error',
      })
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Configurações"
      closeButtonText="Cancelar"
      actionButtonText="Salvar"
      actionButton={handleSave}
      disableButton={!departmentId || isSaving || isLoadingDepartments}
      loading={isSaving}
      dialogSize="sm"
      fullWidth
    >
      <Grid container spacing={2} className={classes.gridContainer}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            label="Seu nome (responsável)"
            value={responsibleName}
            onChange={(event) => setResponsibleName(event.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            options={departments}
            getOptionLabel={(option) => option.name || ''}
            getOptionSelected={(option, selected) => option.id === selected.id}
            value={
              departments.find(
                (department) => department.id === departmentId,
              ) || null
            }
            onChange={(event, option) => setDepartmentId(option?.id || null)}
            noOptionsText="Nenhum departamento encontrado"
            loading={isLoadingDepartments}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Departamento *"
                variant="outlined"
              />
            )}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

UserSettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}

export default UserSettingsDialog
